module.exports = __webpack_public_path__ + "static/media/trimex_medallaplata.45eb1d8c.png";